// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"80d7a59c","124":"96dcf2f4"}[chunkId] + ".chunk.js";
};